import { defineField, defineType } from 'sanity'

export default defineType({
  name: 'centerCapSize',
  title: 'Center Cap Sizes',
  type: 'document',
  orderings: [
    {
      title: 'Size A-Z',
      name: 'sizeAsc',
      by: [{field: 'size', direction: 'asc'}],
    },
  ],
  fields: [
    defineField({
      name: 'size',
      title: 'Size',
      type: 'string',
      validation: (rule: any) => rule.required(),
    }),
    defineField({
      name: 'disclaimer',
      title: 'Disclaimer',
      type: 'text',
    }),
  ],
})